import { Alert, Button, Container, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import LoadingComponent from "src/components/application/LoadingComponent";
import { useUkUserCountry } from "./useUkOnboardingStatus";

// Entity onboarding is not available for UK clients. This gate blocks UK
// users from the entity (Sumsub KYB) flow — whether they arrive via a direct
// URL, an old link, or a stale resume checkpoint — so no Sumsub entity
// applicant is ever created for them. Non-UK clients fall straight through
// to children.
export default function UKEntityOnboardingGate({ children }: { children: ReactNode }) {
  const history = useHistory();
  const { isUkUser, countryReady } = useUkUserCountry();

  // Until the country is known we can't tell whether the block applies —
  // hold off on mounting entity onboarding so no Sumsub applicant is
  // created early.
  if (!countryReady) {
    return <LoadingComponent message="Getting things ready for you..." />;
  }

  if (!isUkUser) {
    return <>{children}</>;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Stack spacing={3}>
        <Alert severity="info">
          <Typography variant="body1" fontWeight={600} gutterBottom>
            Entity accounts aren&apos;t available in the UK
          </Typography>
          <Typography variant="body2">
            We don&apos;t currently offer entity (company) accounts to UK clients. You can
            open an individual account instead.
          </Typography>
        </Alert>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
          <Button
            variant="outlined"
            color="inherit"
            size="large"
            onClick={() => history.push("/portfolio")}
          >
            Back to Portfolio
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => history.push("/application")}
          >
            Continue Individual Application
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
